import { Digtective } from '..';

export function isSessionExpired(facade: Digtective, session: any) {
  if (!session) return false;
  const now = new Date();
  const expiry = new Date(session.expires);
  return now > expiry;
}
